/*
 * @Author: 周泽飞 zefei.zhou@tongdun.net
 * @Date: 2023-02-06 10:52:41
 * @LastEditors: 周泽飞 zefei.zhou@tongdun.net
 * @LastEditTime: 2023-02-08 15:38:40
 * @FilePath: /tntd/packages/tntd/src/collapse/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Collapse from 'antd/lib/collapse'

import 'antd/lib/collapse/style'
import './collapse.less'
export * from 'antd/lib/collapse'

export default Collapse
